import {
  WithGAButtonClickProps,
  WithGAPromoClickProps,
  withGAClickButton,
  withGAPromoClick,
} from 'common/hocs';
import { Link, LinkProps } from './link';

export * from './link';
export type LinkWithGAClickButtonProps = LinkProps & WithGAButtonClickProps;
export type LinkWithGAPromoClickProps = LinkProps & WithGAPromoClickProps<HTMLAnchorElement>;
export const LinkWithGAClickButton = withGAClickButton<LinkWithGAClickButtonProps>(Link);
export const LinkWithGAPromoClick = withGAPromoClick<HTMLAnchorElement, LinkWithGAPromoClickProps>(Link);
